import '../styles/components/Hero.css';
import { m } from 'framer-motion';

const captionStagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12, delayChildren: 0.15 },
  },
};

const captionItem = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-carousel">
        <m.div
          className="hero-caption"
          variants={captionStagger}
          initial="hidden"
          animate="visible"
        >
          <m.div className="hero-kicker" variants={captionItem}>
            HIGH EFFICIENCY &amp; GOOD SERVICE
          </m.div>
          <m.h1 className="hero-title" variants={captionItem}>
            We are committed to continuously
            <br />
            improve product quality and
            <br />
            service level
          </m.h1>
          <m.a className="hero-cta" href="#services" variants={captionItem}>
            Read More &gt;
          </m.a>
        </m.div>

        <m.img
          src="/img/abl9.jpeg"
          alt="ABL construction project"
          className="hero-image"
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>
    </section>
  );
}

export default Hero;
